export default {
  apiUrl: '//pix.wix.com/services/youtube',
  apiUrlCategories: '//pix.wix.com/services/youtube/categories',
};



// WEBPACK FOOTER //
// ./src/transport/adapters/youtube/settings.js